import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivityFold } from './activityFold';

export const Activities = () => {
  const navigate = useNavigate();
  const { issueId } = useParams();

  const onIssueSelected = (issueId: string) => {
    navigate(`/activities/${issueId}`);
  };

  const handleDataLoaded = useCallback((data: any[]) => {
    if (data?.length > 0 && !issueId) {
      onIssueSelected(data[0].id);
    }
  }, [issueId]);

  return (
    <ActivityFold
      onIssueSelected={onIssueSelected}
      showAssetName={true}
      selectedIssue={issueId}
      onDataLoaded={handleDataLoaded}
    />
  );
};
